import type * as SchemaTypes from '../../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchResultQueryVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
}>;


export type FetchResultQuery = (
  { __typename: 'Query' }
  & { assessmentResult: (
    { __typename: 'AssessmentResult' }
    & ResultDataFragment
  ) }
);

export type ResultDataFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'userId' | 'moduleInstanceId' | 'completedAt'>
  & { user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, result: { __typename: 'CardioRespResult' } | { __typename: 'IndividualMotivationResult' } | (
    { __typename: 'ML360Result' }
    & ResultMl360ResultFragment
  ) | (
    { __typename: 'SartResult' }
    & ResultSartResultFragment
  ) | (
    { __typename: 'SelfDeterminationResult' }
    & ResultSelfDeterminationResultFragment
  ) | (
    { __typename: 'SpatialPlanningResult' }
    & ResultSpatialPlanningResultFragment
  ) | { __typename: 'StrengthResult' } | (
    { __typename: 'TeamResilienceResult' }
    & ResultTeamResilienceResultFragment
  ) | { __typename: 'TrainersNotesResult' } | (
    { __typename: 'VisualReactionResult' }
    & ResultVisualReactionResultFragment
  ), assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
    & { program?: SchemaTypes.Maybe<(
      { __typename: 'Program' }
      & Pick<SchemaTypes.Program, 'name'>
    )> }
  )> }
);

export type ResultSelfDeterminationResultFragment = (
  { __typename: 'SelfDeterminationResult' }
  & { surveys: Array<(
    { __typename: 'SelfDeterminationSurveyResult' }
    & Pick<SchemaTypes.SelfDeterminationSurveyResult, 'category' | 'question'>
    & { scoring: (
      { __typename: 'LikertScaleResult' }
      & Pick<SchemaTypes.LikertScaleResult, 'score' | 'total' | 'label'>
    ) }
  )>, categoryAverages: Array<(
    { __typename: 'SelfDeterminationCategoryAverage' }
    & Pick<SchemaTypes.SelfDeterminationCategoryAverage, 'category' | 'maximumPossibleScore' | 'averageScore'>
  )> }
);

export type ResultMl360ResultFragment = (
  { __typename: 'ML360Result' }
  & { surveys: Array<(
    { __typename: 'ML360SurveyResult' }
    & Pick<SchemaTypes.Ml360SurveyResult, 'category' | 'question'>
    & { scoring: (
      { __typename: 'Scoring' }
      & Pick<SchemaTypes.Scoring, 'label' | 'score'>
    ) }
  )>, categoryAverages: Array<(
    { __typename: 'ML360CategoryResult' }
    & Pick<SchemaTypes.Ml360CategoryResult, 'category' | 'averageScore' | 'maxScore'>
  )> }
);

export type ResultSartResultFragment = (
  { __typename: 'SartResult' }
  & Pick<SchemaTypes.SartResult, 'correctHits' | 'misses' | 'incorrectPresses' | 'averageResponseTimeMs' | 'fastestResponseTimeMs'>
  & { trials: Array<(
    { __typename: 'SartTrialResult' }
    & Pick<SchemaTypes.SartTrialResult, 'index' | 'stimulusDigit' | 'responseTimeMs' | 'isTriggerDigit' | 'isCorrect' | 'errorType'>
  )> }
);

export type ResultSpatialPlanningResultFragment = (
  { __typename: 'SpatialPlanningResult' }
  & Pick<SchemaTypes.SpatialPlanningResult, 'correctAnswers' | 'incorrectAnswers' | 'accuracy' | 'averageResponseTimeMs' | 'fastestResponseTimeMs'>
  & { trials: Array<(
    { __typename: 'SpatialPlanningTrialResult' }
    & Pick<SchemaTypes.SpatialPlanningTrialResult, 'index' | 'correctMoves' | 'respondedMoves' | 'numberOfAttempts' | 'responseTimeMs' | 'isCorrect'>
  )> }
);

export type ResultVisualReactionResultFragment = (
  { __typename: 'VisualReactionResult' }
  & Pick<SchemaTypes.VisualReactionResult, 'correctAnswers' | 'incorrectAnswers' | 'fastestResponseTimeMs' | 'averageResponseTimeMs' | 'accuracy'>
  & { rounds: Array<(
    { __typename: 'VisualReactionRoundResult' }
    & Pick<SchemaTypes.VisualReactionRoundResult, 'accuracyPerRound' | 'averageResponseTimeMsPerRound'>
    & { questions: Array<(
      { __typename: 'VisualReactionQuestionResult' }
      & Pick<SchemaTypes.VisualReactionQuestionResult, 'isCorrect' | 'responseTimeMs' | 'errorType'>
    )> }
  )> }
);

export type ResultTeamResilienceResultFragment = (
  { __typename: 'TeamResilienceResult' }
  & { surveys: Array<(
    { __typename: 'TeamResilienceSurveyResult' }
    & Pick<SchemaTypes.TeamResilienceSurveyResult, 'category' | 'subcategory' | 'question'>
    & { scoring: (
      { __typename: 'LikertScaleResult' }
      & ResultTeamResilienceLikertScaleFragment
    ) | (
      { __typename: 'RatingScaleResult' }
      & ResultTeamResilienceRatingScaleFragment
    ) }
  )>, categoryAverages: Array<(
    { __typename: 'TeamResilienceCategoryAverage' }
    & Pick<SchemaTypes.TeamResilienceCategoryAverage, 'category' | 'maximumPossibleScore' | 'averageScore'>
  )>, subcategoryAverages: Array<(
    { __typename: 'TeamResilienceSubcategoryAverage' }
    & Pick<SchemaTypes.TeamResilienceSubcategoryAverage, 'category' | 'subcategory' | 'maximumPossibleScore' | 'averageScore'>
  )> }
);

export type ResultTeamResilienceLikertScaleFragment = (
  { __typename: 'LikertScaleResult' }
  & Pick<SchemaTypes.LikertScaleResult, 'type' | 'score' | 'total' | 'label'>
);

export type ResultTeamResilienceRatingScaleFragment = (
  { __typename: 'RatingScaleResult' }
  & Pick<SchemaTypes.RatingScaleResult, 'type' | 'score' | 'minimumValue' | 'maximumValue'>
);

export const ResultSartResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultSartResult on SartResult {
  trials {
    index
    stimulusDigit
    responseTimeMs
    isTriggerDigit
    isCorrect
    errorType
  }
  correctHits
  misses
  incorrectPresses
  averageResponseTimeMs
  fastestResponseTimeMs
}
    `;
export const ResultSpatialPlanningResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultSpatialPlanningResult on SpatialPlanningResult {
  trials {
    index
    correctMoves
    respondedMoves
    numberOfAttempts
    responseTimeMs
    isCorrect
  }
  correctAnswers
  incorrectAnswers
  accuracy
  averageResponseTimeMs
  fastestResponseTimeMs
}
    `;
export const ResultVisualReactionResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultVisualReactionResult on VisualReactionResult {
  rounds {
    questions {
      isCorrect
      responseTimeMs
      errorType
    }
    accuracyPerRound
    averageResponseTimeMsPerRound
  }
  correctAnswers
  incorrectAnswers
  fastestResponseTimeMs
  averageResponseTimeMs
  accuracy
}
    `;
export const ResultMl360ResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultML360Result on ML360Result {
  surveys {
    ... on ML360SurveyResult {
      category
      question
      scoring {
        ... on Scoring {
          label
          score
        }
      }
    }
  }
  categoryAverages {
    category
    averageScore
    maxScore
  }
}
    `;
export const ResultSelfDeterminationResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultSelfDeterminationResult on SelfDeterminationResult {
  surveys {
    category
    question
    scoring {
      score
      total
      label
    }
  }
  categoryAverages {
    category
    maximumPossibleScore
    averageScore
  }
}
    `;
export const ResultTeamResilienceLikertScaleFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultTeamResilienceLikertScale on LikertScaleResult {
  type
  score
  total
  label
}
    `;
export const ResultTeamResilienceRatingScaleFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultTeamResilienceRatingScale on RatingScaleResult {
  type
  score
  minimumValue
  maximumValue
}
    `;
export const ResultTeamResilienceResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultTeamResilienceResult on TeamResilienceResult {
  surveys {
    category
    subcategory
    question
    scoring {
      __typename
      ... on LikertScaleResult {
        ...ResultTeamResilienceLikertScale
      }
      ... on RatingScaleResult {
        ...ResultTeamResilienceRatingScale
      }
    }
  }
  categoryAverages {
    category
    maximumPossibleScore
    averageScore
  }
  subcategoryAverages {
    category
    subcategory
    maximumPossibleScore
    averageScore
  }
}
    `;
export const ResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment ResultData on AssessmentResult {
  id
  userId
  user {
    ... on BaseUser {
      id
      name
    }
  }
  moduleInstance {
    name
  }
  moduleInstanceId
  completedAt
  result {
    ... on SartResult {
      ...ResultSartResult
    }
    ... on SpatialPlanningResult {
      ...ResultSpatialPlanningResult
    }
    ... on VisualReactionResult {
      ...ResultVisualReactionResult
    }
    ... on ML360Result {
      ...ResultML360Result
    }
    ... on SelfDeterminationResult {
      ...ResultSelfDeterminationResult
    }
    ... on TeamResilienceResult {
      ...ResultTeamResilienceResult
    }
  }
  assessmentRun {
    name
    program {
      name
    }
  }
}
    `;
export const FetchResultDocument = /*#__PURE__*/ gql`
    query FetchResult($id: ObjectID!) {
  assessmentResult(id: $id) {
    ...ResultData
  }
}
    ${ResultDataFragmentDoc}
${ResultSartResultFragmentDoc}
${ResultSpatialPlanningResultFragmentDoc}
${ResultVisualReactionResultFragmentDoc}
${ResultMl360ResultFragmentDoc}
${ResultSelfDeterminationResultFragmentDoc}
${ResultTeamResilienceResultFragmentDoc}
${ResultTeamResilienceLikertScaleFragmentDoc}
${ResultTeamResilienceRatingScaleFragmentDoc}`;

/**
 * __useFetchResultQuery__
 *
 * To run a query within a React component, call `useFetchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchResultQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchResultQuery(baseOptions: Apollo.QueryHookOptions<FetchResultQuery, FetchResultQueryVariables> & ({ variables: FetchResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchResultQuery, FetchResultQueryVariables>(FetchResultDocument, options);
      }
export function useFetchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchResultQuery, FetchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchResultQuery, FetchResultQueryVariables>(FetchResultDocument, options);
        }
export function useFetchResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchResultQuery, FetchResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchResultQuery, FetchResultQueryVariables>(FetchResultDocument, options);
        }
export type FetchResultQueryHookResult = ReturnType<typeof useFetchResultQuery>;
export type FetchResultLazyQueryHookResult = ReturnType<typeof useFetchResultLazyQuery>;
export type FetchResultSuspenseQueryHookResult = ReturnType<typeof useFetchResultSuspenseQuery>;
export type FetchResultQueryResult = Apollo.QueryResult<FetchResultQuery, FetchResultQueryVariables>;